import { AuthenticatedLayout } from "../../../../layouts";
import { FC } from "react";
import { ErrorTransactions } from "../../../../components/DirectDeposit/Transactions/ErrorTransactions";

export interface IErrorTransacitonsPage { }

export const ErrorTransacitonsPage: FC<IErrorTransacitonsPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Error Transactions"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<ErrorTransactions />}
		/>
	);
};
